module.exports = __webpack_public_path__ + "static/media/neonVid.9c543e25.mp4";